export const RevenueReportTypes = {
  SUMMARY: "Summary",
  DETAILS: "Details",
};
